// src/pages/BlogList.js
import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const { local } = useParams();
  const fetchPosts = async () => {
    const snap = await getDocs(collection(db, "blog"));
    const data = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

    data.sort((a, b) => {
      if (!a.createdAt || !b.createdAt) return 0;
      return b.createdAt.seconds - a.createdAt.seconds;
    });

    setPosts(data);
  };

  useEffect(() => {
    fetchPosts();
  }, []);

return (
  <div className="min-h-screen bg-[#0f0a07] text-[#f5f1ea] py-24">
    <div className="max-w-6xl mx-auto px-6 lg:px-20">

      <h1 className="text-4xl md:text-5xl font-serif text-center mb-16 text-[#c6a15b]">
        Blog
      </h1>

      <p className="max-w-3xl mx-auto leading-relaxed text-lg opacity-90 mb-20">
        Ten blog to miejsce, w którym pokazuję, co naprawdę dzieje się podczas tych seansów – poza tym, co widać na filmikach i relacjach. 
        Piszę o tym, jak dobieram olejki i muzykę, dlaczego w jednej saunie ludzie siedzą do końca, a w drugiej wychodzą po 4 minuty, co czuje saunamistrz, kiedy temperatura skacze powyżej 100 °C i robi się cisza, 
        jak wygląda przygotowanie do dużej ceremonii dla 60 osób i dlaczego czasem po prostu gaszę światło i nic nie mówię.
        Jeśli kiedykolwiek wyszedłeś z sauny i pomyślałeś „to było coś innego”, to właśnie o tym tu piszę.

      </p>

      <div className="grid md:grid-cols-2 gap-10">
        {posts.map((post) => (
          <Link
            key={post.id}
            to={`/${local}/blog/${post.slug}`}
            className="group bg-[#14100d] border border-[#2a1f17] rounded-2xl overflow-hidden hover:border-[#c6a15b] transition-all duration-300"
          >
            {post.coverUrl && (
              <div className="w-full overflow-hidden">
                <img
                  src={post.coverUrl}
                  alt={post.title}
                  className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
            )}

            <div className="p-8">
              <h2 className="text-2xl font-semibold mb-4 text-[#c6a15b]">
                {post.title}
              </h2>

              {post.createdAt?.seconds && (
                <p className="text-sm opacity-60">
                  {new Date(post.createdAt.seconds * 1000).toLocaleDateString(
                    "pl-PL",
                    { year: "numeric", month: "long", day: "numeric" }
                  )}
                </p>
              )}
            </div>
          </Link>
        ))}
      </div>

    </div>
  </div>
);

}
